import { useQuery } from '@tanstack/react-query';
import { jobService } from '../services/jobService';
import { format, parseISO, isValid } from 'date-fns';

export const useCalendarJobs = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['calendarJobs'],
    queryFn: () => jobService.getCalendarJobs().then(res => res.data.data || {}),
  });

  let jobs = [];

  if (data && typeof data === 'object') {
    Object.keys(data).forEach(dateKey => {
      const dayJobs = data[dateKey] || [];

      dayJobs.forEach(job => {
        const timePart = job.start_time?.split(':').slice(0, 2).join(':') || '00:00';
        const fullDateTime = `${dateKey}T${timePart}:00`;
        const jobDate = parseISO(fullDateTime);

        // Skip jobs with invalid dates
        if (!isValid(jobDate)) {
          return;
        }

        jobs.push({
          id: job.id,
          jobId: job.job_number || `JOB-${job.id}`,
          date: jobDate,
          title: `${job.client_name} - ${job.boat_info || 'Survey'}`,
          client: {
            first_name: job.client_name.split(' ')[0] || '',
            last_name: job.client_name.split(' ').slice(1).join(' ') || '',
          },
          service: { name: job.boat_info || 'Boat Survey' },
          location: job.location || 'No location',
          start: format(jobDate, 'MMM d, yyyy • h:mm a'),
          surveyors: job.surveyors?.map(s => ({ id: s.id, full_name: s.name })) || [],
          raw: job,
        });
      });
    });
  }

  return { jobs, isLoading, error };
};